import React, { useEffect, useState } from 'react';
import { t } from 'i18n';

import Icon from 'Components/Base/Icon';

const i18nOpts = { scope: 'base.invite_qr_code' };

const LABEL_STATE = {
  DEFAULT: 'DEFAULT',
  COPIED: 'COPIED',
  HIDDEN: 'HIDDEN',
};

const CopyContactText = ({ text }) => {
  const [labelState, setLabelState] = useState(LABEL_STATE.DEFAULT);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (labelState === LABEL_STATE.COPIED) {
        setLabelState(LABEL_STATE.HIDDEN);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [labelState]);

  const copyToClipboard = () => {
    navigator.clipboard?.writeText(text);
    setLabelState(LABEL_STATE.COPIED);
  };

  return (
    <div
      className="phone_copy"
      onClick={copyToClipboard}
      onKeyDown={({ key }) => {
        if (key === 'Enter' || key === ' ') copyToClipboard();
      }}
      onMouseLeave={() => setLabelState(LABEL_STATE.DEFAULT)}
      onBlur={() => setLabelState(LABEL_STATE.DEFAULT)}
      role="button"
      tabIndex="0"
    >
      <span className="phone_copy_text">{text}</span>
      {labelState !== LABEL_STATE.HIDDEN && (
        <span className="phone_copy_label">
          <Icon name="copy" />
          {labelState === LABEL_STATE.COPIED ? t('copied', i18nOpts) : t('copy', i18nOpts)}
        </span>
      )}
    </div>
  );
};

export default CopyContactText;
